import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

// Open/Close strip icon for the PDP config gallery. Stroke-based so it inherits
// `color` like the sibling dimensions icon.
const IconOpenClose = t0 => {
  const $ = _c(12);
  const {
    color: t1,
    width: t2,
    height: t3,
    className: t4
  } = t0;
  const color = t1 === undefined ? colorGray : t1;
  const width = t2 === undefined ? "24" : t2;
  const height = t3 === undefined ? "24" : t3;
  const className = t4 === undefined ? "" : t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M4 13.5 L4 7 a1.5 1.5 0 0 1 1.5 -1.5 L7 5.5 a1.5 1.5 0 0 1 1.5 1.5 L8.5 13" />;
    t6 = <path d="M3.5 13.5 L13.5 13.5 a1.5 1.5 0 0 1 1.5 1.5 L15 17.5 L4 17.5 Z" />;
    t7 = <path d="M15 15.5 L20 14 a1 1 0 0 1 1.2 0.8 L21.4 16 a1 1 0 0 1 -0.8 1.1 L15.5 18" />;
    t8 = <path d="M10 3.2 a6 6 0 0 1 5.2 2.4" />;
    t9 = <path d="M15.8 4 L15.4 6 L13.4 5.4" />;
    $[0] = t5;
    $[1] = t6;
    $[2] = t7;
    $[3] = t8;
    $[4] = t9;
  } else {
    t5 = $[0];
    t6 = $[1];
    t7 = $[2];
    t8 = $[3];
    t9 = $[4];
  }
  let t10;
  if ($[5] !== color) {
    t10 = <g stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">{t5}{t6}{t7}{t8}{t9}</g>;
    $[5] = color;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== className || $[8] !== height || $[9] !== t10 || $[10] !== width) {
    t11 = <svg width={width} height={height} viewBox="0 0 24 24" className={className} fill="none">{t10}</svg>;
    $[7] = className;
    $[8] = height;
    $[9] = t10;
    $[10] = width;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};
IconOpenClose.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default IconOpenClose;